<template>
  <div class="shop-order-list">
      <div class="item-list">
          <div class="all-item">
              <div class="flx header">
                  <h4><span class="select-all" @click="selectAllUnsettledOrder()" v-if="selectAllUnsettled">
                Select All</span>
                <span class="select-all" @click="unSelectAllUnsettledOrder()" v-if="unSelectAllUnsettled">
                UnSelect All</span>List of Customers</h4>
                    <span class="closePopUp" @click="$emit('closePopUp')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                            <path
                            fill="#CDCDCD"
                            fill-rule="nonzero"
                            d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                            opacity=".675"
                            />
                        </svg>
                    </span>
              </div>
              
    <ul>
        
      <li v-for="(order, index) in orders" :key="index">
                <div class="date-detail"  :class="{'paddingLeft' : order.subOrderDTOList[0].distributor == null}">
                  <label v-if="order.subOrderDTOList && order.subOrderDTOList.length">
              <input
                type="checkbox"
                :value="order.subOrderDTOList[0].subOrderId"
                v-model="checkedOrderIds"
                v-if="order.subOrderDTOList[0].distributor!= null"
              />
              <span class="checkmark" v-if="order.subOrderDTOList[0].distributor != null" />
      <div class="product-info flx">
              <p class="order-id-detail" style="padding-top:4px">
                Order ID  - <strong style=" color: #505050;">#{{ order.orderId }}   </strong>           
              </p>
              <p class="order-id-detail" style="padding-top:4px">
                SubOrder ID  - <strong style=" color: #505050;">#{{ order.subOrderDTOList[0].subOrderId }}   </strong>           
              </p>              
          </div>
          <div v-if="order.orderState !== 'CANCELLED_BY_USER'">
          
          <div  class="customer-info">
            <p class="name"> {{replcePhoneWithAsterik(order.addressDTO.personName)}}
              </p>
              <p class="call">
                  <a :href="'tel:'+ order.addressDTO.contactNumber"> <img src="../../assets/images/icons/ic_call.svg" /><span>{{ order.addressDTO.contactNumber}}</span></a>
              </p>
          </div>
          
          </div> 
                  </label>
                </div>
      </li>
    </ul>
          </div>
          <button type="button" @click="orderMarkAsDispatched()" class="pick-up-btn" v-if="checkedOrderIds.length">Pick Up</button>
      </div>
    <infinite-loading @infinite="getOrdersListing" :identifier="resetIdentifier" spinner="circles" style="    color: #fff !important;">
      <template slot="no-more">{{$t('noMoreRecord')}}</template>
    </infinite-loading>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <div class="cancel-popup-wrapper" v-if="orderMarkdispatchedPopUp">
      <div class="cancel-popup">
          <img src="../../assets/images/icons/confirm-red.svg" alt="loader" />
          <p>धन्यवाद! आपका आर्डर कन्फर्म कर दिया गया है ।</p>
        <span class="closePopUp" @click="goToListing()">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#727272"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>      
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>

<script>
import constant from "../../utils/constant";
import InfiniteLoading from "vue-infinite-loading";
import CustomToaster from "../../components/Common/CustomToaster";
import ApiCaller from "../../utils/apicaller";
import { replcePhoneWithAsterik } from '../../utils/helper';
import Vue from "vue";
export default {
  name: "ShopOrderList",
  components: {
    InfiniteLoading,
    CustomToaster
  },
  data() {
    return {
      limit: 20,
      orderIndex: 0,
      orders: [],
      toasterData: {},
      isToasterData: false,
      loading: false,
      resetIdentifier: +new Date(),
      selectAllUnsettled: false,
      unSelectAllUnsettled: false,
      checkedOrderIds: [],
      orderMarkdispatchedPopUp: false
    };
  },
  props: {
      itemId: {

      }
  },
  methods: {
    replcePhoneWithAsterik,
    selectAllUnsettledOrder(){      
      this.checkedOrderIds = []
      this.orders.forEach(order =>{
        if(order.subOrderDTOList && order.subOrderDTOList.length && order.subOrderDTOList[0].distributor != null){
          this.selectAllUnsettled = false;
          this.unSelectAllUnsettled = true
          this.checkedOrderIds.push(order.subOrderDTOList[0].subOrderId)
        }
      })
    },
    unSelectAllUnsettledOrder(){
      this.selectAllUnsettled = true;
      this.unSelectAllUnsettled = false
      this.checkedOrderIds = []
    },
    orderMarkAsDispatched(){
        if(!this.checkedOrderIds.length)
        return

      this.loading = true;
      const obj = {
        subOrderIds: this.checkedOrderIds,
        orderState: 'ORDER_DISPATCHED'
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "change-sub-order-state-bulk",
        "post",
        obj
      ).then(data =>{
        try {
          JSBridgePlugin.fireEvents("ORDER_MARKED_DISPATCHED");
        } catch (err) {
          console.log(err);
        }
        this.loading = false;
        this.$emit('markedDispatch')
      }).catch(err=>{
        this.loading = false
         if (
          err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
          err.response.data.message ==
            "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
        ) {
          this.loading = false;
          try {
            _JWT.refereshToken = (res) => {
              if (res != "fail") {
                this.$cookie.set("JWT-TOKEN", res);
                this.orderMarkAsDispatched(value);
              } else {
                this.loading = false;
              }
            };
            JSBridgePlugin.refreshTokens("_JWT.refereshToken");
          } catch (err) {
            this.loading = false;
            console.log(err);
          }
        }else{
           this.toasterData = {
                msg: err.response.data.message,
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
              return false;
        }
        console.log(err)
      })
    },
    getOrdersListing($state) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        
          ApiCaller(
            constant.LOCAL_SHOP_URL_ORDER,
              `get-shop-order-list-for-item/${this.$route.query.shopid}/${this.itemId}/${this.limit}/${this.orderIndex}`,
            "get"
          )
          .then((data) => {
            this.loading = false;
            if (data.data.length > 0) {              
              this.orders.push(...data.data);
              this.orderIndex += 1;
              this.orders.forEach(order =>{
                  if(order.subOrderDTOList && order.subOrderDTOList.length && order.subOrderDTOList[0].distributor != null){
                    this.selectAllUnsettled = true;
                    this.unSelectAllUnsettled = false
                  }
                })
              $state && $state.loaded();
              
            } else {    
              this.loading = false          
              $state && $state.complete();
            }
          })
          .catch((err) => {
            this.loading = false;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getOrdersListing($state);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }
          });
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.select-all{
  display: flex;
    align-items: center;
  width: max-content;
  font-size: .75em;
  padding: 4px 8px;
  font-weight: 500;
  border-radius: 4px;
  background: #0275d8;
  border-color: #0275d8;
  // box-shadow: 2px 2px 4px 0 rgb(0 0 0 / 70%);
  // text-shadow: 2px 2px 5px rgb(0 0 0 / 50%);
  line-height: normal;
  color: #fff;
  margin-bottom: 8px;
  margin-right: 8px;
  .material-icons{
    padding-right: 8px;
        font-size: 18px;
  }
}
.date-detail {
    padding-left: 32px;
    position: relative;
    &.paddingLeft{
    padding-left: 0;
}
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    top: 0;
    left: 0;
  }

  input:checked ~ .checkmark:after {
    display: block;
    // background: #138808;
  }

  input:checked ~ .checkmark {
    border-color: #138808;
    background: #fff;
  }

  .checkmark {
    position: absolute;
    left: 0;
    background: #fff;
    border-radius: 100%;
    border: 1px solid #ddd;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    margin-top:0 !important;

    &::after {
      // transform: translate(-50%, -50%);
      // left: 50%;
      // top: 50%;
      width: 9px;
      height: 14px;
      // border-radius: 100%;
      // background: #138808;
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
      content: '';
      position: absolute;
      display: none;
      border-bottom: 4px solid #138808;
      border-right: 4px solid #138808;
      transform: rotate(45deg);
      left: 5px;
      top: 2px;
    }
  }
}
.pick-up-btn{
        position: fixed;
    bottom: 0;
    width: calc(100% - 16px);
    background: orange;
    z-index: 99;
    border: 0;
    padding: 8px;
    color: #fff;
    margin: 8px;
    font-weight: 600;
    border-radius: 5px;
}
.item-list{
      position: fixed;
    z-index: 99;
    width: 100%;
    top: 0;
    background: #00000030;
    left: 0;
    bottom: 0;
  .all-item{
      max-height: 100vh;
    overflow: scroll;
    position: relative;
    width: 100%;
    bottom: 0;
    z-index: 99;
    background: #fff;
    
    height: 100%;
    .header{
        padding: 15px;
        border-bottom: 1px solid #ccc;
        position: fixed;
        width: 100%;
        z-index: 9;
        background: #fff;
        top: 0;
        h4{
            display: flex;
        }
    }
    ul{
        padding: 58px 15px;
        li{
            box-shadow: none;
            border:0;
            border-radius: 0;
            border-bottom: 1px dashed #ccc;
            margin-bottom: 0;
            .product-info{
                position: relative;
                .order-id-detail{
                    color: #505050;
                    font-size: 0.75em;
                    strong{
                        font-size: 1.05em;
                    }
                }
            }
            .customer-info{
                // display: block;
                .call{
                    background: none;
                    // padding: 8px 0 0;
                    a{
                        color: #505050;
                        display: flex;
                        align-items: center;
                        img{
                            background: #18A0FB;
                            padding: 6px;
                            border-radius: 50%;
                        }
                        span{                            
                            background: #18A0FB;
                            color: #fff;
                            padding: 3px 5px;
                            font-size: 0.875em;
                            margin-left: -5px;
                            border-radius: 2px;
                        }
                    }
                }
            }
        }
    }
  }
}
</style>